angular.module('app').factory('configsService', [
    'Restangular',
    'settings',
    'userStorage',
    function (Restangular, settings, userStorage) {
        var restAngular = Restangular.withConfig(function (Configurer)
        {
            Configurer.setBaseUrl(settings.apiURL);
        });

        var configs = restAngular.all("/config/");

        return {
            getConfigsMenu: function (requestData) {
                if (requestData) {
                    return configs.
                        one("get").
                        customGET(param(requestData));
                }
                return configs.
                    one("get").
                    get();
            },
            getConfigByConfigSkinId: function (configId) {
                return configs.
                    one("get").
                    get({config_id: configId})
            },
            deleteConfig: function (requestData) {
                return configs.
                    one("deleteConfig").
                    customGET(param(requestData))
            },
            deleteSkinConfig: function (requestData) {
                return configs.
                    one("deleteSkinConfig").
                    customGET(param(requestData))
            },
            updateConfigByConfigSkinId: function (configData) {
                return configs.
                    one("change").
                    post("", {config: configData})
            },
            generateJs: function (requestData) {
                requestData = requestData || {};
                return configs.
                    one("generateJSOrApplyMobile").
                    post("", requestData)
            },
            createConfig: function (configData) {
                return configs.
                    one("create").
                    post("", {config: configData})
            },
            editConfig: function (configData) {
                return configs.
                    one("changeTree").
                    post("", {config: configData})
            },
            getConfigTypes: function () {
                return configs.
                    one("getTypes").
                    get()
            },
            searchConfig: function (requestConfig) {
                return configs.
                    one("searchConfig").
                    customGET(param(requestConfig))
            },
            searchConfigSkin: function (requestConfig) {
                return configs.
                    one("searchConfigSkin").
                    customGET(param(requestConfig))
            },
            applyConfigs: function (requestData) {
                if (userStorage.getUserData().permissions.indexOf('viewSkins') !== -1 ) {
                    return configs.
                        one("applyAll").
                        get()
                }
                return configs.
                    one("apply").
                    post("", requestData)
            },
            applyConfigsBySkinId : function (requestData) {
                return configs.
                    one("apply").
                    post("", requestData)
            },
            applyPayments: function (requestData) {
                return configs.
                    one("apply").
                    post("", requestData)
            },
            addConfigsSkins: function (requestData) {
                return configs.
                    one("addConfigsSkins").
                    post("", requestData)
            },
            getVersionsBySkinId: function (skinId) {
                return configs.
                    one("getSkinConfigVersions").
                    get({skin_id: skinId})
            },
            revertConfigVersion: function (configVersionId, message) {
                var requestData = {
                    initial_version_id: configVersionId,
                    message: message
                };
                return configs.
                    one("revertSkinConfigVersion").
                    post("", {revertSkinConfig: requestData})
            },
            duplicateConfig: function (requestData) {
                return configs.
                    one("duplicateConfig").
                    customGET(param(requestData))
            },
            generateSkinConfigs: function(requestData){
                return configs.
                one("generateSkinConfigs").
                customGET(param(requestData))
            }
        }
    }
]);
